function pop(storageKey: string) {
  const value = localStorage.getItem(storageKey);
  localStorage.removeItem(storageKey);

  return value;
}

export default pop;
